import { useEffect, useState } from 'react';

// Vídeo de depoimento do Instagram. Para trocar o vídeo, mude o link abaixo.
const LINK_VIDEO = 'https://www.instagram.com/reel/C9U9dKasVxT/?utm_source=ig_embed';

// Primeiro aparece só uma capa com o botão de play; o vídeo do Instagram
// (que é pesado e enche o console de avisos) só carrega quando a pessoa clica.
const VideoInstagram = () => {
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    if (!aberto) return;
    // Se o script do Instagram já estiver na página, só pede para montar o vídeo
    if (window.instgrm) {
      window.instgrm.Embeds.process();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
  }, [aberto]);

  return (
    <div className="instagram-video">
      {aberto ? (
        <blockquote
          className="instagram-media"
          data-instgrm-permalink={LINK_VIDEO}
          data-instgrm-version="14"
        />
      ) : (
        <button type="button" className="instagram-capa" onClick={() => setAberto(true)}>
          <span className="instagram-capa-play" aria-hidden="true">&#9654;</span>
          <span className="instagram-capa-texto">Assista ao depoimento</span>
          <span className="instagram-capa-sub">Vídeo do nosso Instagram</span>
        </button>
      )}
    </div>
  );
};

const DepoimentosSection = () => (
  <section className="testimonials">
    <div style={{ textAlign: 'center', marginTop: 15 + 'px' }}>
      <h2 className='titulo-secao'>O que os pais dizem sobre nós</h2>
    </div>
    <div className="testimonial-cards">
      <div className="testimonial-card">
        <div className="testimonial-content">
            <p>"Excelente Colégio. Moderno e com uma educação próxima para as crianças."</p>
            <div className="testimonial-author">
                <div className="author-initials">DS</div>
                <div className="author-details">
                    <strong>Daniella Santana</strong>
                    <span>Mãe de aluno</span>
                </div>
            </div>
        </div>
      </div>
      <div className="testimonial-card">
        <div className="testimonial-content">
            <p>"Até agora sem reclamações! Gostei muito da escola e principalmente do acolhimento e educação da coordenação."</p>
            <div className="testimonial-author">
                <div className="author-initials">ES</div>
                <div className="author-details">
                    <strong>Elaine Souza</strong>
                    <span>Mãe de aluno</span>
                </div>
            </div>
        </div>
      </div>
    </div>
    <VideoInstagram />
  </section>
);

export default DepoimentosSection;
